module.exports = "https://trybtryb-legacy.web.app/img/blur-special-desktop.1a950ed2.svg";